import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import StudentPage from '../../views/StudentPage';

class StudentCategory extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			stdcat : '',
			_message : '',
			alertClass :'',
			posts : [],
			_redirect : false,
			isedit : 0,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("editform").reset();
		this.setState({isedit : 0,stdcat : ''});
		document.getElementById("stcatform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.stdcat){
			$("#showLoader").show();	
			PostData('student/addcat',this.state).then((result) => {
				$("#showLoader").hide();	
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Category Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("stcatform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		
		if (window.confirm("Do you want to Delete?")) { 
		$("#showLoader").show();	
			PostData('student/deletecategory',this.state).then((result) => {
				$("#showLoader").hide();	
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Student Category Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Student Category',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdateSubmit(e){
		e.preventDefault();
		
		if(this.state.stdcat){
			$("#showLoader").show();
			PostData('student/editcategory',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				
				if(responseJson.status == '1' ){
					document.getElementById("editform").reset();
					this.setState({
						_message:'Category Updated Successfully!..',
						alertClass:'alert alert-success',
						isedit : 0
					});
					this.getdata();
				}
				else{
					this.setState({
						_message:'Category Already Added..',
						alertClass:'alert alert-danger'
					});
				}
			});	
		}
	}

	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();	
		GetData('student/getcategory').then((result) => {
			$("#showLoader").hide();	
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	handleEditClick(id){

		var index = this.state.posts.findIndex(function(obj){
			return (obj.id == id);
		})
		this.setState({stdcat : this.state.posts[index]['category'], id :id,isedit : 1});
	}

  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/leave/editcategory/' + this.state.idd} />);

	}
	
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				{this.state.isedit == 0 ?
				  <Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="stcatform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Student Category</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Student Category <span className="text-danger">*</span></Label>
								  <Input type="text" name="stdcat" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col> : 
					<Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="editform" encType="multipart/form-data" onSubmit={this.onUpdateSubmit} >
						<CardHeader>
							<strong>Edit Category</strong>
							<Button type="reset" size="sm" color="primary" style={{float : 'right'}} onClick={this.onClick}>Add</Button>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Student Category <span className="text-danger">*</span></Label>
								  <Input type="text" name="stdcat" required onChange={this.onChange} value={this.state.stdcat} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col> }
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Category</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
						  {this.state.posts.map((item,index) =>
							<tr key = {item}>
								<td>{index+1}</td>
								<td>{item.category}</td>
								<td>
								<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.handleEditClick(item.id)} ><i className="fa fa-edit"></i></button>&nbsp;
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>
						  )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default StudentCategory;


// WEBPACK FOOTER //
// ./src/student/StudentCategory/StudentCategory.js